const API_BASE = '/api'

/**
 * Make an API request
 */
async function request(method, path, data = null) {
  const token = localStorage.getItem('facility_token')

  const options = {
    method,
    headers: {
      'Content-Type': 'application/json'
    }
  }

  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`
  }

  if (data && (method === 'POST' || method === 'PUT' || method === 'DELETE')) {
    options.body = JSON.stringify(data)
  }

  const response = await fetch(`${API_BASE}${path}`, options)

  // Handle non-JSON responses (like CSV export)
  const contentType = response.headers.get('content-type')
  if (contentType && !contentType.includes('application/json')) {
    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`)
    }
    return response
  }

  const result = await response.json()

  if (!response.ok) {
    throw new Error(result.error || `HTTP error ${response.status}`)
  }

  return result
}

export default {
  get: (path, params = {}) => {
    const searchParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        searchParams.append(key, value)
      }
    })
    const queryString = searchParams.toString()
    return request('GET', queryString ? `${path}?${queryString}` : path)
  },

  post: (path, data) => request('POST', path, data),

  put: (path, data) => request('PUT', path, data),

  delete: (path, data) => request('DELETE', path, data)
}
